import { useState } from "react";
import { KnowYourCustomerModal } from "@features/KnowYourCustomerModal/KnowYourCustomerModal";
import { useModalStore } from "@store/modal/modal";
import { prefetchKycCurrentForm } from "@services/knowYourCustomer/queries";

export const useKycFormOpen = () => {
  const { create } = useModalStore();
  const [isPrefetching, setIsPrefetching] = useState(false);

  const open = async (options?: { onPause?: () => void }) => {
    setIsPrefetching(true);
    await prefetchKycCurrentForm();
    setIsPrefetching(false);
    return create((modalProps) => (
      <KnowYourCustomerModal {...modalProps} {...options} />
    ));
  };

  return {
    isPrefetching,
    open,
  };
};
